import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { TDataToken, TQueries } from "./type";

export const pendingUserList = (data: TDataToken,queries) => {
  return $api
    .get(
      `/admin/invite/org/${queries.orgID}`,
     { token: data.accessToken}
    )
    .then((response) => {
      return response
    });
};
export const usePendingUserList = (
  data: TDataToken,
  queries: TQueries,
  config?: {}
) => {
  return useQuery({
    queryKey: ["pendingUserList"],
    queryFn: () => pendingUserList(data,queries),
    ...(config as UseQueryOptions<any>),
  });
};
